import { render, staticRenderFns } from "./BCNetworkLTE.vue?vue&type=template&id=21ca6f9c"
import script from "./BCNetworkLTE.vue?vue&type=script&lang=js"
export * from "./BCNetworkLTE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports